module.exports = __webpack_public_path__ + "static/assets/95290c2c4dcdadfa53b566572e792b9c.png";